import { Output, EventEmitter } from '@angular/core';
import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { UploadedFile } from '../../models/uploaded-file.model';

@Component({
standalone: false,
  selector: 'app-added-file-row',
  templateUrl: './added-file-row.component.html',
  styleUrls: ['./added-file-row.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class AddedFileRowComponent {
  @Input() file: UploadedFile;
  @Input() index: number;
  @Input() remove: (index: number) => void;
  @Output() showPreview = new EventEmitter();
}
